import styles from '../../../assets/modal.module.css';

export default styles;
